import $ from 'jquery';
import _ from 'underscore';
import UI from 'root/ui';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Form from 'root/module/form';
import Modals from 'root/modals';
import View from 'root/view/base';

const Monday_Send = View.extend({
    send_options: null,
    fields: {},

    board_id: '',
    groups: [],
    title: '',

    form_value : {
        title: ''
    },

    events: {
        'click .dropdown-board li' : 'onSelectBoard',
        'click .dropdown-group li' : 'onSelectGroup',
        'submit form'              : 'onSubmit',
        'click .reconnect'         : 'onReconnect'
    },

    dom_handlers: {
        onSelectBoard: function (e) {
            this.board_id = `${$(e.currentTarget).data('id')}`;
            this.group_id = this.searchBoard(this.board_id).groups[0].id || '';

            this.renderBoards();
            this.renderGroups();
        },

        onSelectGroup: function (e) {
            this.group_id = $(e.currentTarget).data('id');
            this.renderGroups();
        },

        onSubmit: function () {
            const form_data = Form.getData(this.$el.find('form'));

            this.$el.find('button[type="submit"]').prop('disabled', true).addClass('loading');

            this.$el.find('.mask-light').show();
            this.$el.find('.progress-loader').width('0%').show();
            let progress = 0;
            const timeout = setInterval(() => {
                progress = Math.min(90, progress + Math.random() * 15);
                this.$el.find('.progress-loader').width(`${progress}%`);
            }, 50);

            const data = _.extend(form_data, {
                feedback_id: this.model.get('id')
            });

            Cache.app.request({
                action: 'integration/sendFeedbackToMonday',
                context: this,
                data,
                success: function (response) {
                    this.model.set('monday_url', response.monday_url);

                    setTimeout(() => {
                        UI.success('Task created in Monday');
                        this.trigger('submit:success');
                    }, 800); // wait for animation to finish
                },
                complete: function () {
                    this.$el.find('button[type="submit"]').prop('disabled', false).removeClass('loading');

                    clearInterval(timeout);
                    this.$el.find('.progress-loader').width('100%');
                }
            });
        },

        onReconnect: function () {
            var connected_app = Cache.connected_app_monday.get(Cache.integration_monday.findWhere({project_id: this.model.get('project_id')})?.get('app_id') || 0);

            if (connected_app) {
                Modals.reconnectConnectedApp(connected_app.get('app_type'), connected_app, () => {
                    Modals.sendToMonday(this.model.id);
                });
            } else {
                window.parent.location = '/account/connected_app';
            }
        }
    },

    initialize: function () {
        this.form_value = {
            title: ''
        };

        if (this.model.isDesign() || this.model.isPdf() || this.model.isVideoUpload()) {
            this.title = `Feedback for ${this.model.get('page')}`;
        } else {
            this.title = `Feedback #${Util.padLeft(this.model.id, '000000')}`;
        }

        if (this.model.get('title')) {
            this.form_value.title = this.model.get('title');
        }

        this.fields = {};

        this.group_id = this.board_id ? this.searchBoard(this.board_id).groups[0].id : '';
    },

    loadOptions: function () {
        var cache_key = 'monday_send_options_' + Cache.integration_monday.findWhere({project_id: this.model.get('project_id')})?.get('monday_board_id') || '';

        if (Cache.get(cache_key)) {
            this.loadOptionsSuccess(Cache.get(cache_key));
        } else {
            Cache.app.request({
                action: 'integration/loadSendOptions',
                data: {
                    type: 'monday',
                    project_id: this.model.get('project_id')
                },
                context: this,
                success: function (response) {
                    if (response.boards?.length) {
                        Cache.add(cache_key, response, false);
                        this.loadOptionsSuccess(response);
                    } else {
                        this.renderError();
                    }
                },
                error: function () {
                    this.renderError();
                }
            });
        }
    },

    loadBoardInfo: function () {
        Cache.app.request({
            action: 'integration/loadSendOptions',
            data: {
                type: 'monday_board',
                project_id: this.model.get('project_id'),
                board_id: this.board_id
            },
            context: this,
            success: function (response) {
                let board_index;
                this.send_options.boards.forEach((board, index) => {
                    if (board.id === this.board_id) {
                        board_index = index;
                    }
                });

                if (board_index !== undefined) {
                    this.send_options.boards[board_index] = response;
                    this.renderGroups();
                }
            }
        });
    },

    loadOptionsSuccess: function (response) {
        const default_board_id = Cache.integration_monday.findWhere({project_id: this.model.get('project_id')})?.get('monday_board_id') || '';

        this.send_options = response;
        const board = this.searchBoard(default_board_id);
        this.board_id = board ? default_board_id : response.boards[0].id;
        this.group_id = board.groups?.length > 0 ? board.groups[0].id : '';
        this.render();
    },

    searchBoard: function (board_id) {
        return this.send_options?.boards?.find(b => b.id === board_id) || false;
    },

    searchGroup: function (board_id, group_id) {
        const groups = this.searchGroups(board_id);
        return groups.find(g => g.id === group_id) || false;
    },

    searchGroups: function (group_id) {
        const board = this.searchBoard(group_id);
        return Array.isArray(board?.groups) ? board.groups : [];
    },

    renderError: function () {
        const message =
        '<div class="error-dialog padding-30">' +
            '<div class="icon"><i class="fas fa-exclamation"></i></div>' +
            '<h3>Authentication failed</h3>' +
            `<p class="info">We couldn't connect to your Monday account.</p>${
                Cache.app.isAdmin() ?
                    '<button class="reconnect primary medium">Reconnect Monday</button>' +
            '<div class="divider-20"></div>' : ''
            }</div>`;

        this.$el.html(message);
    },

    renderBoards: function () {
        const board_selected = this.searchBoard(this.board_id);
        const board_items = this.send_options?.boards.map(
            b => `<li data-id="${b.id}" ${this.board_id === b.id ? 'class="selected"' : ''}>${Util.htmlEntities(b.name)}</li>`
        ).reduce((a, b) => a + b, '');

        const content = `
<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-board" data-append="true">
    <button type="button" class="dropdown-select">${Util.htmlEntities(board_selected.name)}</button>
    <div>
        <div class="dropdown-search">
            <input type="text" class="solid compact" placeholder="Search by board name">
        </div>
        <ul class="dropdown dropdown-select">${board_items || ''}</ul>
    </div>
</div>
<input type="hidden" name="board" value="${this.board_id}">`;

        this.$el.find('.region-boards').html(content);
    },

    renderGroups: function () {
        const board = this.searchBoard(this.board_id);
        const group_items = board.groups?.map(
            g => `<li data-id="${g.id}" ${this.group_id === g.id ? 'class="selected"' : ''}>${Util.htmlEntities(g.title)}</li>`
        ).reduce((a, s) => a + s) || '';
        const title_map = board.groups?.reduce((a, g) => ({ ...a, [g.id]: g.title }), {}) || {};

        const content = `
<div class="button-dropdown button-dropdown-full button-dropdown-left dropdown-group" data-append="true">
    <button type="button" class="dropdown-select">${Util.htmlEntities(title_map[this.group_id] || 'No Group Selected')}</button>
    <div>
        <div class="dropdown-search">
            <input type="text" class="solid compact" placeholder="Search by group name">
        </div>
        <ul class="dropdown dropdown-select">${group_items}</ul>
    </div>
</div>
<input type="hidden" name="group" value="${this.group_id}">`;

        this.$el.find('.region-groups').html(content);
    },

    render: function () {
        const content_loading = `
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-medium margin-bottom-20"></div>
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-medium margin-bottom-20"></div>
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-medium margin-bottom-20"></div>
<div class="loader-placeholder margin-bottom-8" style="width:100px;"></div>
<div class="loader-placeholder-large"></div>`;

        const content_form = `
<div class="row">
    <div class="field-label">Board <i class="fas fa-asterisk"></i></div>
    <div class="region-boards"></div>
</div>
<div class="row">
    <div class="field-label">Group <i class="fas fa-asterisk"></i></div>
    <div class="region-groups"></div>
</div>
<div class="row">
    <div class="field-label">Task Title</div>
    <input type="text" name="title" maxlength="255" class="solid compact" placeholder="${Util.htmlEntities(this.title)}">
</div>
<div class="row">
    <div class="field-label">Description</div>
    <textarea name="body" class="solid compact" rows="3"></textarea>
</div>`;

        const content = `
<div class="progress-loader"></div>
<div class="mask-light" style="display:none;"></div>
<form class="form-fluid">
    <div class="modal-integration-innerscroll">
       ${this.send_options ? content_form : content_loading}
    </div>
    <div class="modal-integration-innerscroll-footer">
        <button type="submit" class="primary" ${this.send_options ? '' : 'disabled'}>Send</button>
    </div>
</form>`;

        this.$el.html(content);

        if (this.form_value.title) {
            Form.setData(this.$el.find('form'), {
                title: this.form_value.title
            });
        }

        if (this.send_options) {
            this.renderBoards();
            this.renderGroups();
        } else {
            this.loadOptions();
        }

        return this;
    }
});

export default Monday_Send;
